import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/whatsapp-templates")({
  component: lazyRouteComponent(() => import("./-pages/admin.whatsapp-templates")),
  head: () => ({
    meta: [
      { title: "WhatsApp Templates · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
